import { useEffect } from 'react';


import { useNavigate } from 'react-router-dom';

import LandingPage from 'pages/landingPage/LandingPage';
import { useUserProfile } from 'store';

export default function HomeRedirector() {
    const user = useUserProfile();
    const navigate = useNavigate();

    useEffect(() => {
        if (user?.role === 'model' && user.username) {
            navigate(`/${user.username}`, { replace: true });
        } else if (user?.role === 'fan') {
            navigate('/following', { replace: true });
        }
        // If not logged in, do nothing (LandingPage will render below)
    }, [user, navigate]);

    if (user?.role === 'model' && user.username) return null;
    if (user?.role === 'fan') return null;
    // Otherwise, show landing/tour
    return <LandingPage />;
}